import { capitalize } from '../../../helpers/string'
import {
  formatDateWithFormat,
  ignoreTimezoneDate,
  sameDay,
} from '../../../helpers/date'
import { PostEventCard } from '../../../generated/api/post-row'

type EventDates = Pick<PostEventCard, 'startDate' | 'endDate' | 'isAllDay'>

export const eventDateString = (event: EventDates): string => {
  const dates = sameDay(new Date(event.endDate), new Date(event.startDate))
    ? [event.startDate]
    : [event.startDate, event.endDate]

  return capitalize(
    dates
      .map((_date) =>
        formatDateWithFormat(
          ignoreTimezoneDate(new Date(_date)),
          'eee d MMM yyyy'
        )
      )
      .join(' - ')
  )
}

export const eventTimeString = (
  event: EventDates,
  allDayLabel: string
): string => {
  if (event.isAllDay) {
    return allDayLabel
  }

  return [event.startDate, event.endDate]
    .map((_date) =>
      formatDateWithFormat(ignoreTimezoneDate(new Date(_date)), 'HH:mm')
    )
    .join(' - ')
}
